/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb115Inputs */

const en__field_enum_pbs_fb115 = /** @type {(inputs: _Field_Enum_Pbs_Fb115Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 11 Faculty of Geosciences and Geography`)
};

const de__field_enum_pbs_fb115 = /** @type {(inputs: _Field_Enum_Pbs_Fb115Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 11 Geowissenschaften und Geographie`)
};

/**
* | output |
* | --- |
* | "F 11 Faculty of Geosciences and Geography" |
*
* @param {_Field_Enum_Pbs_Fb115Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb115 = /** @type {((inputs?: _Field_Enum_Pbs_Fb115Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb115Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb115(inputs)
	return de__field_enum_pbs_fb115(inputs)
});
export { _field_enum_pbs_fb115 as "_field_enum_PBS_FB11" }